export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    accordionClasses() {
      const routePath = this.$route.path
      const locale = this.$i18n.locale
      if (routePath === '/en' && locale === 'en') return 'type--en'

      return false
    },
  },
}
